<template>
  <div id="app">
    <div class="wrapper">
      <headerNav></headerNav>
      <router-view class="main_content" />
      <bottom></bottom>
      <top v-show="navBarFixed" @totop="backToTop"></top>
    </div>
  </div>
</template>
<script>
import bottom from "./components/bottom.vue";
import headerNav from "./components/headerNav.vue";
import top from "./components/top.vue";
export default {
  data() {
    return {
      navBarFixed: false
    };
  },
  components: {
    bottom,
    headerNav,
    top
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 49) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    backToTop() {
      let distanceY = window.pageYOffset;
      let i = 0;
      this.interval = setInterval(() => {
        let next = Math.floor(
          this.easeInOutQuad(10 * i, distanceY, -distanceY, 500)
        );
        if (next <= 0) {
          window.scrollTo(0, 0);
          clearInterval(this.interval);
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 8);
    },
    /*
      缓动公式（Tween算法）
       t: 动画已经执行的时间（实际上时执行多少次/帧数）
       b: 起始位置
       c: 终止位置
       d: 从起始位置到终止位置的经过时间（实际上时执行多少次/帧数）
    */
    easeInOutQuad(t, b, c, d) {
      // 判断当前时间是否总在总时间的一半以内，是的话执行缓入函数，否则的话执行缓出函数
      if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
      } else {
        // 将总长度设置为一半，并且时间从当前开始递减，对图像进行垂直向上平移
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      }
    }
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  }
};
</script>
<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #fff;
  padding-top: 120px;
  display: flex;
  .wrapper {
    display: -webkit-flex;
    display: -ms-flex; /* 兼容IE */
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
  }
  .main_content {
    // -ms-flex: 1 0 auto; /* 兼容IE */
    // flex-grow: 1 0 auto;
    // flex: 1 1 auto
    flex-grow: 1;
  }
}
</style>
<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #4c0104;
  color: #ffe900;
}
.el-pagination {
  margin: 0 0 37px 40px;
}
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
.ellipsis_muti {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  background: #4c0104;
  color: #ffe900;
}
</style>
